import { useState } from "react";

export interface FaqItem {
  q: string;
  a: string;
}

export default function FaqList({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span className="flex items-start gap-3 flex-1 min-w-0">
                  <span className="mt-0.5 text-xs font-label text-accent-700 bg-accent-100 px-2 py-0.5 rounded shrink-0">
                    Q{index + 1}
                  </span>
                  <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.q}
                  </span>
                </span>
                <span className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-700">
                  <i
                    className={isOpen ? "ri-subtract-line" : "ri-add-line"}
                    aria-hidden="true"
                  ></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="pb-6 pl-0 md:pl-14">
                <p className="text-sm md:text-base leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}